import endpoints from "../config/endpoints.json";
import connection_production from "../config/connection-production.json";
import connection_local from "../config/connection-local.json";
import connection_development from "../config/connection-development.json";
import axios from "axios";
import type { ApiResponse } from "../types";

const connection =
  process.env.REACT_APP_NODE_ENV === "local"
    ? connection_local
    : process.env.REACT_APP_NODE_ENV === "development"
    ? connection_development
    : process.env.REACT_APP_NODE_ENV === "production"
    ? connection_production
    : connection_local;

/**
 * Announcement
 */
export const queryLearnerAnnouncementDTOList = async (params): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.notification.url}${endpoints.notifications.announcements.actions.context}${endpoints.notifications.announcements.actions.learner.query.dto.context}`,
      params
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const queryLearnerAnnouncementFeed = async (params): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.notification.url}${endpoints.notifications.announcements.actions.context}${endpoints.notifications.announcements.actions.learner.query.dto["with-unread-count"].context}`,
      params
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const retrieveLearnerNumberOfUnReadAnnouncements = async (params): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.notification.url}${endpoints.notifications.announcements.actions.context}${endpoints.notifications.announcements.actions.learner["number-of-unread"].context}`,
      params
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const createAnnouncementActionByAnnouncementId = async (
  newNotificationAction
): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.notification.url}${endpoints.notifications.announcements.actions.context}${endpoints.notifications.announcements.actions["by-announcementId"].context}`,
      newNotificationAction
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};

export const createAnnouncementActionsByAnnouncementIdList = async (
  newNotificationActionList
): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${connection.base.notification.url}${endpoints.notifications.announcements.actions.context}${endpoints.notifications.announcements.actions.read["by-announcementIdList"].context}`,
      newNotificationActionList
    );
    return { data: response.data, status: response.status };
  } catch (err) {
    return { err };
  }
};
